import React, { useState } from "react";
import { CButton, CForm, CFormInput, CFormLabel } from "@coreui/react-pro";
import userServices from "../../services/user";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../contexts/AlertContext";

function LoginBlog() {
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("login"); // "login" | "forgot"
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const { showAlert } = useAlert();

  const defaultUserData = { email: "", password: "" };
  const [user, setUser] = useState(defaultUserData);
  const navigate = useNavigate();

  async function login() {
    setIsLoading(true);
    const res = await userServices.login(user);
    if (!res.success) {
      showAlert(res.message, "error");
      setIsLoading(false);
      return;
    }
    navigate("/");
    setIsLoading(false);
  }

  async function handleForgotPassword() {
    setIsLoading(true);
    setForgotMessage("");
    const res = await userServices.requestPasswordReset({ email: forgotEmail });
    setForgotMessage(res.message);
    setIsLoading(false);
  }

  return (
    <>
      <div id="login-blog">
        <div className="align">
          <div className="img">
            <span style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, color: "#fff", fontSize: "2rem", textAlign: "center", display: "block" }}>Cartório Nova Veneza</span>
            <div className="identifier">
              <p>
                Cartório Nova Veneza © 2026 | A Software develop by{" "}
                <a href="https://singlec.com.br/" target="_blank" rel="noreferrer">
                  Singlec
                </a>
              </p>
            </div>
          </div>

          {mode === "login" ? (
            <CForm>
              <div>
                <h1 className="mb-2">Realizar login</h1>
                <p className="mb-4">
                  Ao acessar nossos sistemas, saiba que sua atividade é rastreada
                  e seus dados são protegidos por criptografia, conforme exigido
                  pela Lei Geral de Proteção de Dados Pessoais (LGPD) para sua
                  segurança.
                </p>
                <div className="align-form">
                  <div>
                    <CFormLabel>E-mail:</CFormLabel>
                    <CFormInput
                      type="email"
                      placeholder=""
                      value={user.email}
                      onChange={(e) => setUser((prev) => ({ ...prev, email: e.target.value }))}
                    />
                  </div>
                  <div>
                    <CFormLabel className="mt-4">Senha:</CFormLabel>
                    <CFormInput
                      type="password"
                      placeholder=""
                      value={user.password}
                      onChange={(e) => setUser((prev) => ({ ...prev, password: e.target.value }))}
                    />
                  </div>
                  <CButton className="mt-4" type="button" disabled={isLoading} onClick={login}>
                    {isLoading ? "Carregando..." : "Entrar"}
                  </CButton>
                  <button
                    type="button"
                    className="forgot-link"
                    onClick={() => { setMode("forgot"); setForgotMessage(""); }}
                  >
                    Esqueci minha senha
                  </button>
                </div>
              </div>
            </CForm>
          ) : (
            <CForm>
              <div>
                <h1 className="mb-2">Recuperar senha</h1>
                <p className="mb-4">
                  Informe seu e-mail cadastrado e enviaremos um link para redefinir sua senha.
                </p>
                <div className="align-form">
                  <div>
                    <CFormLabel>E-mail:</CFormLabel>
                    <CFormInput
                      type="email"
                      placeholder=""
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                    />
                  </div>
                  {forgotMessage && (
                    <p className="mt-3 forgot-message">{forgotMessage}</p>
                  )}
                  <CButton className="mt-4" type="button" disabled={isLoading} onClick={handleForgotPassword}>
                    {isLoading ? "Enviando..." : "Enviar"}
                  </CButton>
                  <button
                    type="button"
                    className="forgot-link"
                    onClick={() => { setMode("login"); setForgotMessage(""); }}
                  >
                    Voltar ao login
                  </button>
                </div>
              </div>
            </CForm>
          )}
        </div>
      </div>
    </>
  );
}

export default LoginBlog;
